class InfiniteScroll extends HTMLElement {
    constructor() {
        super();
        this.initGrid();
        this.initObserver();
        this.currentPage = 1;
        this.productGridContainer = document.querySelector('.product-grid-facets-container');
        this.scrollToTopBtn = document.querySelector('.scroll-to-top-button');
        this.loaderContainer = document.querySelector('.infinite-loading-box');
        this.reachedEndText = document.querySelector('.end-of-grid');

        const headerHeightValue = document.documentElement.style.getPropertyValue('--header-height');
        this.headerHeight = parseInt(headerHeightValue?.match(/\d+/)?.[0] ?? '0', 10) || 0;
        this.productGridContainerTop = this.productGridContainer.getBoundingClientRect().top;

        this.scrollToTopBtn.addEventListener('click', this.scrollToTop.bind(this));

        window.addEventListener('scroll', this.toggleScrollToTopButton.bind(this));
    }

    initGrid() {
        let gridName = "product-grid";
        let grid = document.getElementById(gridName);
        if (grid) {
            this.gridName = gridName;
            this.gridContainer = grid;
        }
    }

    initObserver() {
        const observer = new IntersectionObserver(this.revealItem.bind(this), {
            root: null,
            threshold: 0.05,
        });
        observer.observe(this);
    }

    fetchNextPage(pageNumber) {
        const nextPath = this.dataset.next;
        if (!nextPath || pageNumber > this.dataset.pageSize) return;

        const url = new URL(nextPath, window.location.origin);
        url.searchParams.set('page', pageNumber);

        fetch(url.href, {
            method: 'GET',
            credentials: 'same-origin',
            headers: {
                'Accept': 'text/html',
                'X-Requested-With': 'XMLHttpRequest'
            }
        })
                .then((response) => response.text())
                .then((htmlContent) => {
                    const parsedDocument = new DOMParser().parseFromString(htmlContent, 'text/html');
                    const nextProductsHtml = parsedDocument.getElementById(this.gridName).innerHTML;

                    // FIX-61423 Extraction de l'URL exacte next page depuis le HTML reçu
                    const nextPageElement = parsedDocument.querySelector('infinite-scroll');
                    if (nextPageElement) {
                        this.dataset.next = nextPageElement.dataset.next;
                    }

                    this.gridContainer.insertAdjacentHTML('beforeend', nextProductsHtml);

                    if (pageNumber == this.dataset.pageSize) {
                        this.loaderContainer.style.display = "none";
                        this.reachedEndText.style.display = "flex";
                    }
                })
                .then(() => updateSwiperJsAfterProductsGridChanged())
                .catch((error) => {
                    console.error('Error:', error);
                });
    }

    revealItem(entries, observer) {
        const [entry] = entries;

        if (!entry.isIntersecting) return;

        if (entry.target) {
            this.currentPage++;
            this.fetchNextPage(this.currentPage);
        }

        if (this.currentPage == this.dataset.pageSize) {
            observer.unobserve(entry.target);
        }
    }

    getAbsoluteTopPosition(element)
    {
        const rect = element.getBoundingClientRect();
        return rect.top + window.scrollY
    }

    scrollToTop() {
        window.scrollTo({ top: 0, behavior: 'smooth'});
    }

    toggleScrollToTopButton() {
        if (window.scrollY > this.productGridContainerTop)  {
            this.scrollToTopBtn.classList.add('show');
        } else {
            this.scrollToTopBtn.classList.remove('show');
        }
    }
}

customElements.define('infinite-scroll', InfiniteScroll);